import React, { useEffect, useState, useContext } from "react";
import { Col, Row, Button } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import PageLayout from "../../../layouts/PageLayout";
import { Link } from "react-router-dom";
import axios from "axios";
import FilterSelect from "./FilterSelect";
import { useNavigate } from "react-router-dom";
import { SidebarContext } from "../../../context/Sidebar";

// Module download options are only shown to users who can access that module
// (same permission names as the sidebar).
const MODULE_PERMISSIONS = {
  spiritual: ["SpiritualModule"],
  vocational: ["VocationalModule"],
  medical: ["MedicalModule"],
  school_enrollment: ["SchoolModule"],
  act: ["ACTModule", "ActRecord"],
};


export default function AllFamilyFilter() {

  const AuthToken = localStorage.getItem("AuthUser");
  axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;
  const navigate = useNavigate();
  const [filtersData, setFiltersData] = useState({});

  const { hasPermission } = useContext(SidebarContext);
  const [form, setForm] = useState({
    entry_from: "",
    entry_to: "",
    rescued_from: "",
    request_id: "",
    rescued_to: "",
    flagged: "",
    loan_type: "",
    province: "",
    city: "",
    donor: "",
    slavery_reason: "",
    business_type: "",
    follow_up: "",
    module: "",
  });

  const moduleOptions = (filtersData?.modules || []).filter((m) =>
    (MODULE_PERMISSIONS[m.id] || []).some((p) => hasPermission(p))
  );

  // Load initial dropdown data
  useEffect(() => {
    axios.get(process.env.REACT_APP_API_URL + "/filter-initial")
      .then((response) => {
        setFiltersData(response.data);
      });
  }, []);

  // Handle input/select changes
  const handleChange = (e) => {
    console.log(e.target.name, e.target.value);
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  // Send filter request
  const filterFamilies = () => {
    axios.post(process.env.REACT_APP_API_URL + "/filter-data", form)
      .then((response) => {
        console.log("Filtered data:", response.data.data);
        navigate("/filtered-families", {
          state: {
            data: response.data.data,
            module: response.data.module || "",
            moduleLabel: response.data.module_label || "",
            columns: response.data.columns || null,
          }
        });
      })
      .catch((error) => {
        console.error(error);
        alert(error?.response?.data?.message || "Failed to load filtered data");
      });
  };

  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">Filters</h3>
              <ul className="mc-breadcrumb-list">
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link">Home</Link>
                </li>
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link">Data Filter</Link>
                </li>
                <li className="mc-breadcrumb-item">Filters</li>
              </ul>
            </div>
          </div>
        </Col>

        {/* Filter by Entry Date */}
        <Col xl={6}>
          <div className="mc-card">
            <h4>Filter by Entry Date</h4>

            <Form.Group style={{ marginTop: "20px" }}>
              <Form.Label>From</Form.Label>
              <Form.Control type="date" name="entry_from" onChange={handleChange} />
            </Form.Group>

            <Form.Group style={{ marginTop: "20px" }}>
              <Form.Label>To</Form.Label>
              <Form.Control type="date" name="entry_to" onChange={handleChange} />
            </Form.Group>

            <Button style={{ marginTop: "20px" }} onClick={filterFamilies} variant="success">
              Search
            </Button>
          </div>
        </Col>

        {/* Filter by Rescued Date */}
        <Col xl={6}>
          <div className="mc-card">
            <h4>Filter by Rescued Date</h4>

            <Form.Group style={{ marginTop: "20px" }}>
              <Form.Label>From</Form.Label>
              <Form.Control type="date" name="rescued_from" onChange={handleChange} />
            </Form.Group>

            <Form.Group style={{ marginTop: "20px" }}>
              <Form.Label>To</Form.Label>
              <Form.Control type="date" name="rescued_to" onChange={handleChange} />
            </Form.Group>

            <Button style={{ marginTop: "20px" }} onClick={filterFamilies} variant="success">
              Search
            </Button>
          </div>
        </Col>
        {hasPermission("FilterByRequest") && (

          < Col xl={6}>
            <div className="mc-card">
              <h4>Filter by Requests</h4>


              <FilterSelect
                label="Requests"
                name="request_id"
                value={form.request_id}
                options={filtersData?.reqs || []}
                onChange={handleChange}
              />

              <Button style={{ marginTop: "20px" }} onClick={filterFamilies} variant="success">
                Search
              </Button>
            </div>
          </Col>
        )}

        <Col xl={6}>
          <div className="mc-card">
            <h4>Filter by Flagged</h4>

            <Form.Group style={{ marginTop: "20px" }}>
              <Form.Label>Flagged</Form.Label>
              <Form.Select name="flagged" onChange={handleChange}>
                <option value="">Select...</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </Form.Select>
            </Form.Group>

            <Button style={{ marginTop: "20px" }} onClick={filterFamilies} variant="success">
              Search
            </Button>
          </div>
        </Col>

        {/* Filter by City */}
        <Col xl={6}>
          <div className="mc-card">
            <h4>Filter by City</h4>

            <FilterSelect
              label="City"
              name="city"
              value={form.city}
              options={filtersData?.cities || []}
              onChange={handleChange}
            />

            <Button style={{ marginTop: "20px" }} onClick={filterFamilies} variant="success">
              Search
            </Button>
          </div>
        </Col>

        {/* Loan Type */}
        <Col xl={6}>
          <div className="mc-card">
            <h4>Filter by Loan Type</h4>

            <FilterSelect
              label="Loan Type"
              name="loan_type"
              value={form.loan_type}
              options={filtersData?.loanTypes || []}
              onChange={handleChange}
            />

            <Button style={{ marginTop: "20px" }} onClick={filterFamilies} variant="success">
              Search
            </Button>
          </div>
        </Col>

        {/* Donors / Rescued By */}
        {hasPermission("FilterByDonors") && (

          <Col xl={6}>
            <div className="mc-card">
              <h4>Filter by Donor</h4>

              <FilterSelect
                label="Donor"
                name="donor"
                value={form.donor}
                options={filtersData?.donors || []}
                onChange={handleChange}
              />

              <Button style={{ marginTop: "20px" }} onClick={filterFamilies} variant="success">
                Search
              </Button>
            </div>
          </Col>
        )}
        {/* Business Type */}
        <Col xl={6}>
          <div className="mc-card">
            <h4>Filter by Business Type</h4>

            <FilterSelect
              label="Business Type"
              name="business_type"
              value={form.business_type}
              options={filtersData?.business_types || []}
              onChange={handleChange}
            />

            <Button style={{ marginTop: "20px" }} onClick={filterFamilies} variant="success">
              Search
            </Button>
          </div>
        </Col>

        {/* Module (Spiritual / Vocational / Medical / School Enrollment / ACT) */}
        {moduleOptions.length > 0 && (
          <Col xl={6}>
            <div className="mc-card">
              <h4>Filter by Module</h4>

              <FilterSelect
                label="Module"
                name="module"
                value={form.module}
                options={moduleOptions}
                onChange={handleChange}
                placeholder="All Families (default)"
              />
              <Form.Text muted>
                Downloads records of the selected module. Entry Date filters by the record date
                (admission date for School Enrollment, formation date for ACT). ACT uses only
                Entry Date and City.
              </Form.Text>

              <div>
                <Button style={{ marginTop: "20px" }} onClick={filterFamilies} variant="success">
                  Search
                </Button>
              </div>
            </div>
          </Col>
        )}

      </Row>
    </PageLayout >
  );
}
